import React, { Component } from "react";
import { slide as Menu } from "react-burger-menu";
import { connect } from "react-redux";
import background from "./images/material-design-background.jpg";
import avatar from "./images/blank-avatar.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faBullseye, faLock } from "@fortawesome/free-solid-svg-icons";
import getPortlets from "../../_actions/dashboardActions";
import { Link } from "react-router-dom";

import './sibebar.styles.css'

//export default props => {
class SideBar extends Component {
  constructor(props) {
    super(props);
  }

  routeChange(path) {
    this.props.history.push(path);
  }

  render() {
    let user = JSON.parse(localStorage.getItem("user"));
    if (typeof user !== "undefined" || user != null) {
      var pic = "";
      if (user.photoPath) {
        pic = user.photoPath;
      } else {
        pic = avatar;
      }

      const { dashboard } = this.props;

      return (
        // Pass on our props
        <Menu>
          <div className="menu-container">
            <img src={background} className="background" alt="background" />
            <div className="title">
              <img src={pic} alt="profile" />
              <strong> {user.enquiryName}</strong>
              <p>{user.emailId}</p>
            </div>
          </div>
          <div style={{ display: "flex", "flex-direction": "column" }}>
            {dashboard?.data?.portlets.map((portlet) => {
              let params = "";
              if (
                portlet.target === "studyResource" ||
                portlet.target === "lessonPlan"
              ) {
                params =
                  portlet.params.resourceTypeId +
                  "/" +
                  portlet.params.resourceSubTypeId +
                  "/" +
                  portlet.name;
              }
              if (
                portlet.name !== "OnlineTests" &&
                portlet.target === "TestList" &&
                typeof portlet.testCategoryIds !== "undefined"
              ) {
                //localStorage.setItem("TLCategory",portlet.testCategoryIds);
                params = portlet.testCategoryIds;
              }
              return portlet.isTile === true ? (
                <Link
					className="portlet-links"
                  to={{
                    pathname: `${portlet.target}/${params}`,
                    state: { portlet },
                  }}
                >
				<img className="portlet-image" src={portlet.icon} alt="Messages" />
				{portlet.name} 
				</Link>
              ) : null;
            })}
            {/* <Button className={portlet.class+' button button-md button-clear button-clear-md'} onClick={() => this.routeChange(portlet.target+'/'+params,portlet)}></Button> */}

            <a
              style={{ color: "#666", width: "100%" }}
              onClick={() => this.routeChange("/profile")}
            >
              <FontAwesomeIcon icon={faUser} /> My Profile
            </a>
            <a
              style={{ color: "#666", width: "100%" }}
              onClick={() => this.routeChange("/changepassword")}
            >
              <FontAwesomeIcon icon={faLock} /> Change Password
            </a>
            <a href="/logout">
              <FontAwesomeIcon icon={faBullseye} /> Logout
            </a>
          </div>
        </Menu>
      );
    }
  }
}

const mapStateToProps = (state) => {
  console.log(state.dashboard.dashboard, "here");
  return {
    dashboard: state.dashboard.dashboard,
    error: state.dashboard.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPortlets: () => dispatch(getPortlets()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
